import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../lib/api.js';

// API paths
const API_PATHS = {
  INSIGHTS: '/insights',
};

// Thunk for fetching insights
export const fetchInsights = createAsyncThunk('insights/fetchInsights', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get(API_PATHS.INSIGHTS);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch insights');
  }
});

// Initial state
const initialState = {
  insights: { data: [] },
  loading: 'idle', // 'idle' | 'pending' | 'succeeded' | 'failed'
  error: null,
};

// Create the slice
const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: {
    // Add any additional synchronous reducers here
  },
  extraReducers: (builder) => {
    // Handle fetchInsights
    builder
      .addCase(fetchInsights.pending, (state) => {
        state.loading = 'pending';
        state.error = null;
      })
      .addCase(fetchInsights.fulfilled, (state, action) => {
        state.insights = action.payload;
        state.loading = 'succeeded';
      })
      .addCase(fetchInsights.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.payload;
      });
  },
});

// Export selectors
export const selectAllInsights = (state) => state.insights.insights;
export const selectInsightsLoading = (state) => state.insights.loading === 'pending';
export const selectInsightsError = (state) => state.insights.error;

// Export reducer
export default insightsSlice.reducer;
